module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "in-con in-inOne"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "inOne-treatment"
  }, [_c('h2', [_vm._v("看诊时间："), _c('span', {
    attrs: {
      "format": "yyyy-MM-dd"
    }
  }, [_vm._v(_vm._s(this.timeDate.periodOfTime))])]), _vm._v(" "), _c('h2', [_vm._v("看诊医生："), _c('span', [_vm._v(_vm._s(this.timeDate.doctorName))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "显示药价",
      "inactive-text": "隐藏药价"
    },
    model: {
      value: (_vm.priceSwitchVal),
      callback: function($$v) {
        _vm.priceSwitchVal = $$v
      },
      expression: "priceSwitchVal"
    }
  })], 1)]), _vm._v(" "), _c('el-tabs', {
    staticClass: "inOne-TabCon",
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "病历",
      "name": "first"
    }
  }, [_c('inRecords', {
    ref: "c2"
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "中药汤方",
      "name": "second"
    }
  }, [_c('inAdvices', {
    ref: "c3",
    attrs: {
      "priceSwitchVal": _vm.priceSwitchVal
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "处置方法",
      "name": "examine"
    }
  }, [_c('inExamine', {
    ref: "c4"
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "本次测量值",
      "name": "third"
    }
  }, [_c('inChecks', {
    ref: "c5"
  })], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inOne-info"
  }, [_c('h2', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("看诊信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7510e8b1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/inquiry/inquiryOne.vue
// module id = 1028
// module chunks = 2